
import { uploadS3Object } from '@/aws/aws-s3';
import dynamoDB from '@/aws/aws-dynamoDB';

import awsconfig from '@/aws-exports';
import { getJwtToken } from '@/utils/authManager';

export default async function (
  file,
  key,
  alias,
  metadata = {},
  progressCallback = e => e,
  successCallback = e => e,
  errorCallback = e => e,
) {
  try {
    // delete file from database
    const input = {
      id: key,
      userID: getJwtToken().payload.sub,
      userEmail: getJwtToken().payload.email,
      key,
      alias,
      metadata,
    };

    await dynamoDB.createDBFile(input);

    // delete file from storage
    const result = await uploadS3Object(
      file,
      key,
      awsconfig.aws_user_files_s3_bucket,
      progressCallback,
    );

    if (result.$metadata.httpStatusCode >= 200 && result.$metadata.httpStatusCode < 300) {
      successCallback(result);
    } else {
      errorCallback(result);
    }
  } catch (error) {
    errorCallback(error);
  }
}
